import InstanceVolumeSize from './InstanceVolumeSize';

export type InstanceVolumeSizesClassProps = {
    aws: any;
    safespring: any;
    lintasarta: any;
    elastx: any;
    syseleven: any;
};

export interface InstanceVolumeSizesInterface {
    aws: any;
    safespring: any;
    lintasarta: any;
    elastx: any;
    syseleven: any;
}

export default class InstanceVolumeSizes
    implements InstanceVolumeSizesInterface
{
    readonly aws: any;
    readonly safespring: any;
    readonly lintasarta: any;
    readonly elastx: any;
    readonly syseleven: any;

    constructor(props: InstanceVolumeSizesClassProps) {
        this.aws = props.aws;
        if (this.aws) {
            Object.keys(props.aws).map(
                (k: any) =>
                    (this.aws[`${k}`] = new InstanceVolumeSize(props.aws[k]))
            );
        } else {
            this.aws = {};
        }

        this.safespring = props.safespring;
        if (this.safespring) {
            Object.keys(props.safespring).map(
                (k: any) =>
                    (this.safespring[`${k}`] = new InstanceVolumeSize(
                        props.safespring[k]
                    ))
            );
        } else {
            this.safespring = {};
        }

        this.lintasarta = props.lintasarta;
        if (this.lintasarta) {
            Object.keys(props.lintasarta).map(
                (k: any) =>
                    (this.lintasarta[`${k}`] = new InstanceVolumeSize(
                        props.lintasarta[k]
                    ))
            );
        } else {
            this.lintasarta = {};
        }

        this.elastx = props.elastx;
        if (this.elastx) {
            Object.keys(props.elastx).map(
                (k: any) =>
                    (this.elastx[`${k}`] = new InstanceVolumeSize(
                        props.elastx[k]
                    ))
            );
        } else {
            this.elastx = {};
        }

        this.syseleven = props.syseleven;
        if (this.syseleven) {
            Object.keys(props.syseleven).map(
                (k: any) =>
                    (this.syseleven[`${k}`] = new InstanceVolumeSize(
                        props.syseleven[k]
                    ))
            );
        } else {
            this.syseleven = {};
        }
    }
}
